import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const CLOSE_CLAIM_DETAILS_QUERY = graphql(`
  query CloseClaimDetails($claimUuid: String!) {
    closeClaimDetails(claimUuid: $claimUuid) {
      openTask
      unpaidReserve
      missingLossDescription
      missingLossTypeSelection
      missingLossData
    }
  }
`);

export interface IUseCloseClaimDetailsQueryArg {
  claimUuid: string;
}

export function useCloseClaimDetailsQuery({
  claimUuid,
}: IUseCloseClaimDetailsQueryArg) {
  const { loading, data, error, refetch } = useQuery(
    CLOSE_CLAIM_DETAILS_QUERY,
    {
      variables: {
        claimUuid,
      },
    }
  );

  return {
    loading,
    error,
    data: data ? { data } : undefined,
    refetch,
  };
}
